// extracted by mini-css-extract-plugin
export const mainContent = "post-page-module--mainContent--2vmDU";
export const categories = "post-page-module--categories--iFf4g";